import { render, staticRenderFns } from "./areaReviewDetail.vue?vue&type=template&id=8ba6057a&scoped=true&"
import script from "./areaReviewDetail.vue?vue&type=script&lang=js&"
export * from "./areaReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./areaReviewDetail.vue?vue&type=style&index=0&id=8ba6057a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba6057a",
  null
  
)

export default component.exports